const MODE = import.meta.env.MODE;

// tslint:disable: no-console
class Logger {
  debug = (message?: any, ...params: Array<any>) => {
    if (MODE !== 'production') {
      console.debug(message, ...params);
    }
  };

  log = (message?: any, ...params: Array<any>) => {
    if (MODE !== 'production') {
      console.log(message, ...params);
    }
  };

  warn = (message?: any, ...params: Array<any>) => {
    if (MODE !== 'production') {
      console.warn(message, ...params);
    }
  };

  trace = (message?: any, ...params: Array<any>) => {
    if (MODE !== 'production') {
      console.trace(message, ...params);
    }
  };

  table = (message?: any, ...params: Array<any>) => {
    if (MODE !== 'production') {
      console.table(message, ...params);
    }
  };

  error = (message: string, data?: any) => {
    console.error(message, data);
  };

  group = (name: string, collapsed = false) => {
    if (collapsed) {
      console.groupCollapsed(name);
    } else {
      console.group(name);
    }
  };

  groupEnd = () => {
    console.groupEnd();
  };

  time = (name: string) => {
    console.time(name);
  };

  timeEnd = (name: string) => {
    console.timeEnd(name);
  };
}

const logger = new Logger();

export default logger;
